export default __webpack_public_path__ + "img/68c44ecd9ffa6d37fc0991fc83fca1c9.svg";